
<ng-container *ngIf="type.toLowerCase()">
<gen-dynamic-specimen #specimenTypeForm
                       class="Flexbox Flexbox__flex-1"
                       [title]="formTitle"
                       [editMode]="editMode"
                       [form]="form"
                       [sample]="specimen"
                       [specimenType]="specimenType"
                       [sampleType]="sampleType"
                       [index]="index"
                       [formId]="formId"
                       [isSubmitted]="isSubmitted">
</gen-dynamic-specimen>
</ng-container>
